import { useMemo, useCallback } from 'react';
import { isServer } from 'app/libs/environment';
import { useSsrRequest } from 'app/context/common/SsrRequestProvider';
import { uaParser as ua } from '@encarpkg/shared';

// SSR시 요청정보(req.headers.user-agent)를 이용하는 유저에이전트 custom hook
function useSsrUserAgent() {
	const req = useSsrRequest();
	const navigator = useMemo(
		() => (isServer ? { userAgent: req.headers['user-agent'], language: req.headers['accept-language'] } : window.navigator),
		[req],
	);

	return useCallback(() => ua(navigator), [navigator]);
}

export default useSsrUserAgent;
